module.exports = __webpack_public_path__ + "static/media/no_list_profile@2x.46706d68.png";